export const path = "/master-design-roundler";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "MASTER DESIGN",
  section: "ROUNDLER",
  group: null,
  order: 3,
  roles: [
    "Authenticated",
    "roundler-admin",
    "design",
    "design-roundler",
    "master-rrss-roundler",
    "aluna",
  ],
};
